/* eslint-disable no-case-declarations */
import { RichText } from './rich-text';

export const TextSlice = ({ primary, className = '' }) => (
  <RichText className={className} elements={primary.text} />
);
